var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "json-kv-panel" },
    [
      !_vm.entries.length
        ? _c("div", { staticClass: "json-kv-panel-empty" }, [
            _vm._v(_vm._s(_vm.emptyText))
          ])
        : _c(
            "el-row",
            { staticClass: "json-kv-panel-row", attrs: { gutter: 20 } },
            _vm._l(_vm.splitColumns, function(col, colIdx) {
              return _c(
                "el-col",
                { key: colIdx, attrs: { span: 12 } },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "json-kv-panel-form",
                      attrs: { "label-position": "top", size: "small" }
                    },
                    _vm._l(col, function(item) {
                      return _c(
                        "el-form-item",
                        {
                          key: item.key,
                          staticClass: "json-kv-panel-item",
                          attrs: { label: item.label }
                        },
                        [
                          !item.multiline
                            ? _c("el-input", {
                                staticClass: "json-kv-panel-input",
                                attrs: { value: item.display, readonly: "" }
                              })
                            : _c("el-input", {
                                staticClass: "json-kv-panel-textarea",
                                attrs: {
                                  type: "textarea",
                                  value: item.display,
                                  readonly: "",
                                  autosize: { minRows: 2, maxRows: 8 }
                                }
                              })
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            }),
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }